import { render } from "./RegistrosDePonto.vue?vue&type=template&id=e5f1612c&scoped=true"
import script from "./RegistrosDePonto.vue?vue&type=script&lang=js"
export * from "./RegistrosDePonto.vue?vue&type=script&lang=js"

import "./RegistrosDePonto.vue?vue&type=style&index=0&id=e5f1612c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f1612c"]])

export default __exports__